module.exports = __webpack_public_path__ + "static/devoxxbe-51abab812df4d3d112295065c659f03f.png";